import { ManifestError } from './ManifestError';

export class ManifestErrorResponse {
  errors: ManifestError[] = [];

  constructor(opts?: Partial<ManifestErrorResponse>) {
    if (opts?.errors != null) {
      this.errors = opts.errors.map((val) => new ManifestError(val));
    }
  }
}
